import {useMemo} from 'react';

import {ActionVisibility, TVisibleMetaActionProp} from 'entities/metadata';
import {selectIsFormEntityDataEditable} from 'modules/data/data-selectors';
import {useAppSelector} from 'store/config/hooks';

import {EFormMode} from '../form-types';

export const useFormElementsAvailability = (mode: EFormMode, entityName?: string) => {
    const editableSelector = selectIsFormEntityDataEditable(entityName!);
    let isEditable = useAppSelector(state => editableSelector(state));

    const currentActionsVisibleState: TVisibleMetaActionProp = useMemo(
        () => {
            if ((mode === EFormMode.EDIT && isEditable === false)
                || mode === EFormMode.REPRESENTATION) {
                return ActionVisibility.VIEWING;
            }
            if (mode === EFormMode.EDIT && isEditable === true) {
                return ActionVisibility.EDITING;
            }
            if (mode === EFormMode.CREATE) {
                return ActionVisibility.CREATION;
            }
            return ActionVisibility.DEFAULT;
        },
        [isEditable],
    );

    if (mode === EFormMode.REPRESENTATION) {
        isEditable = false;
    }

    if (mode === EFormMode.CREATE) {
        isEditable = true;
    }

    return {
        isEditable,
        currentActionsVisibleState,
    };
};
